import React, { FC } from "react";
import "./CancelButton.scss";

export interface CancelButtonProps {
    tabIndex?: string;
    onClick(): void;
}

const CancelButton: FC<CancelButtonProps> = (props) => {
    return (
        <div
            id="xapp-widget-close"
            aria-label={"close widget"}
            aria-hidden={false}
            tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
            className="cancel-button"
            onClick={props.onClick}>
        </div>
    );
};

export default CancelButton;
